function PhysioPreview({ site }) {
    return (
        <div className="min-h-[820px] bg-[#F8F6F0] font-jakarta text-[#121315]">
            <header className="flex items-center justify-between border-b border-[#E2E0D8] px-8 py-3">
                <div className="flex items-center gap-3">
                    <span className="block h-3 w-3 bg-[#C85A32]" />
                    <span className="font-syne text-sm font-bold uppercase tracking-[0.18em]">
                        {site.name}
                    </span>
                </div>
                <nav className="flex gap-7 font-mono text-[11px] uppercase tracking-[0.2em] text-[#525866]">
                    {site.nav.map((label) => (
                        <span key={label}>{label}</span>
                    ))}
                </nav>
                <span className="border border-[#E2E0D8] bg-[#EAE8DF] px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.15em]">
                    {site.status}
                </span>
            </header>
            <div className="px-8 pt-14">
                <p className="mb-8 font-mono text-[11px] uppercase tracking-[0.3em] text-[#525866]">
                    {site.eyebrow}
                </p>
                <h1 className="font-syne text-[56px] font-bold leading-[0.95] tracking-tighter">
                    Hands-on physiotherapy
                    <br />
                    for people who want to get
                    <br />
                    back to work, sport, and
                    <br />
                    <span className="font-cormorant italic font-medium text-[#C85A32]">
                        ordinary days.
                    </span>
                </h1>
                <div className="mt-10 flex gap-3">
                    {site.pills.map((pill) => (
                        <span
                            key={pill}
                            className="border border-[#121315] px-4 py-2 font-mono text-[11px] uppercase tracking-[0.18em]"
                        >
                            {pill}
                        </span>
                    ))}
                </div>
            </div>
            <div className="mt-14 grid grid-cols-12 gap-4 px-8">
                <figure className="col-span-7">
                    <div className="border border-[#E2E0D8] bg-white p-2">
                        <img
                            src={site.photos[0].src}
                            alt={site.photos[0].alt}
                            className="aspect-[4/3] w-full object-cover grayscale-[35%]"
                        />
                    </div>
                    <figcaption className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-[#525866]">
                        {site.photos[0].caption}
                    </figcaption>
                </figure>
                <figure className="col-span-4 col-start-9 mt-16">
                    <div className="border border-[#E2E0D8] bg-white p-2">
                        <img
                            src={site.photos[1].src}
                            alt={site.photos[1].alt}
                            className="aspect-[3/4] w-full object-cover"
                        />
                    </div>
                    <figcaption className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-[#525866]">
                        {site.photos[1].caption}
                    </figcaption>
                </figure>
            </div>
        </div>
    );
}

function BakeryPreview({ site }) {
    return (
        <div className="relative min-h-[820px] overflow-hidden bg-[#2A1C14] text-[#F6EFE4]">
            <img
                src={site.photos[0].src}
                alt={site.photos[0].alt}
                className="absolute inset-0 h-full w-full object-cover opacity-55"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#2A1C14] via-[#2A1C14]/80 to-transparent" />
            <div className="relative flex h-[820px] flex-col px-12 py-10">
                <header className="flex items-center justify-between">
                    <p className="font-cormorant text-3xl italic">Mill &amp; Rye</p>
                    <nav className="flex gap-8 text-sm tracking-wide text-[#F6EFE4]/70">
                        {site.nav.map((label) => (
                            <span key={label}>{label}</span>
                        ))}
                    </nav>
                </header>
                <div className="mt-auto max-w-lg pb-8">
                    <p className="text-xs uppercase tracking-[0.35em] text-[#E2B07A]">King Street West</p>
                    <h1 className="mt-4 font-cormorant text-[72px] italic leading-[0.9]">
                        Warm bread
                        <br />
                        before the
                        <br />
                        town wakes.
                    </h1>
                    <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#F6EFE4]/75">
                        Sourdough, viennoiserie, and filter coffee. The shop opens at five and the
                        racks are empty by three.
                    </p>
                    <div className="mt-8 space-y-2 border-t border-[#F6EFE4]/20 pt-6 text-sm">
                        <div className="flex justify-between">
                            <span>Country loaf</span>
                            <span className="text-[#E2B07A]">$8</span>
                        </div>
                        <div className="flex justify-between">
                            <span>Kouign-amann</span>
                            <span className="text-[#E2B07A]">$6</span>
                        </div>
                        <div className="flex justify-between">
                            <span>Filter coffee</span>
                            <span className="text-[#E2B07A]">$4</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function LawPreview({ site }) {
    return (
        <div className="grid min-h-[820px] grid-cols-2 bg-[#10151C] text-[#E8E2D6]">
            <div className="flex flex-col justify-between px-12 py-12">
                <div>
                    <p className="font-mono text-[10px] uppercase tracking-[0.45em] text-[#C4A574]">
                        North Bench
                    </p>
                    <div className="mt-4 h-px w-16 bg-[#C4A574]" />
                </div>
                <div>
                    <h1 className="font-cormorant text-[58px] font-light leading-[1.05]">
                        Counsel for
                        <br />
                        families and
                        <br />
                        founders.
                    </h1>
                    <p className="mt-8 max-w-sm text-sm leading-7 text-[#E8E2D6]/65">
                        Independent practice in St. Catharines. Estates, small companies, and the
                        files that should not wait on a downtown firm.
                    </p>
                    <p className="mt-10 font-mono text-[10px] uppercase tracking-[0.28em] text-[#C4A574]">
                        By appointment · Mon–Fri 9–5
                    </p>
                </div>
                <nav className="flex gap-8 font-mono text-[10px] uppercase tracking-[0.22em] text-[#E8E2D6]/45">
                    {site.nav.map((label) => (
                        <span key={label}>{label}</span>
                    ))}
                </nav>
            </div>
            <div className="relative">
                <img
                    src={site.photos[0].src}
                    alt={site.photos[0].alt}
                    className="h-full w-full object-cover grayscale-[20%]"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-[#10151C]/80 px-8 py-5 text-xs tracking-[0.2em] uppercase text-[#C4A574]">
                    Niagara · not a call centre
                </div>
            </div>
        </div>
    );
}

function GymPreview({ site }) {
    return (
        <div className="relative min-h-[820px] overflow-hidden bg-black text-white">
            <img
                src={site.photos[0].src}
                alt={site.photos[0].alt}
                className="absolute inset-0 h-full w-full object-cover opacity-40 grayscale"
            />
            <div className="relative flex h-[820px] flex-col px-10 py-8">
                <header className="flex items-center justify-between">
                    <span className="font-display text-xl font-black tracking-tight">IRONWOOD</span>
                    <span className="bg-[#C8F04D] px-5 py-2 text-xs font-black uppercase tracking-[0.2em] text-black">
                        Join the floor
                    </span>
                </header>
                <div className="mt-auto pb-6">
                    <p className="mb-4 text-sm uppercase tracking-[0.4em] text-[#C8F04D]">
                        Small gym. Heavy work.
                    </p>
                    <h1 className="font-display text-[92px] font-black leading-[0.82] tracking-tighter">
                        LIFT.
                        <br />
                        REST.
                        <br />
                        REPEAT.
                    </h1>
                    <div className="mt-8 flex gap-10 text-sm uppercase tracking-[0.18em] text-white/70">
                        <span>Coached</span>
                        <span>Open gym</span>
                        <span>No contracts</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

function SalonPreview({ site }) {
    return (
        <div className="min-h-[820px] bg-[#F3E6DC] text-[#3B2A24]">
            <div className="grid grid-cols-12">
                <div className="relative col-span-7 min-h-[820px]">
                    <img
                        src={site.photos[0].src}
                        alt={site.photos[0].alt}
                        className="absolute inset-0 h-full w-full object-cover"
                    />
                    <p className="absolute bottom-8 left-8 font-cormorant text-6xl italic text-white">
                        Harbour
                    </p>
                </div>
                <div className="col-span-5 flex flex-col justify-between px-10 py-12">
                    <nav className="flex flex-col gap-2 text-sm lowercase tracking-wide text-[#3B2A24]/55">
                        {site.nav.map((label) => (
                            <span key={label}>{label}</span>
                        ))}
                    </nav>
                    <div>
                        <p className="text-[11px] uppercase tracking-[0.35em] text-[#C45B4A]">Row</p>
                        <h1 className="mt-4 font-cormorant text-[52px] leading-[1.05]">
                            An hour in
                            <br />
                            the chair that
                            <br />
                            actually rests.
                        </h1>
                        <p className="mt-6 text-sm leading-relaxed text-[#3B2A24]/70">
                            Colour, cut, and gloss. Appointments only. The street is two minutes
                            from the harbour.
                        </p>
                    </div>
                    <div className="flex gap-3">
                        {["Cut", "Colour", "Gloss"].map((item) => (
                            <span
                                key={item}
                                className="rounded-full bg-[#3B2A24] px-4 py-2 text-[11px] uppercase tracking-[0.16em] text-[#F3E6DC]"
                            >
                                {item}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

function LandscapePreview({ site }) {
    return (
        <div className="relative min-h-[820px] overflow-hidden bg-[#1C2418] text-[#F1F0E8]">
            <img
                src={site.photos[0].src}
                alt={site.photos[0].alt}
                className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-[#1C2418]/25" />
            <header className="relative flex items-center justify-between px-10 py-8">
                <span className="text-sm tracking-[0.3em] uppercase">Cedar &amp; Stone</span>
                <nav className="flex gap-6 text-xs uppercase tracking-[0.2em] text-white/80">
                    {site.nav.map((label) => (
                        <span key={label}>{label}</span>
                    ))}
                </nav>
            </header>
            <div className="absolute inset-x-8 bottom-8 grid grid-cols-4 gap-px bg-[#1C2418]/20 p-px">
                <div className="col-span-2 bg-[#F1F0E8] p-8 text-[#1C2418]">
                    <p className="text-[11px] uppercase tracking-[0.28em] text-[#6A7F3A]">
                        Niagara crew
                    </p>
                    <h1 className="mt-3 font-syne text-4xl font-semibold leading-tight">
                        Gardens that
                        <br />
                        hold in July.
                    </h1>
                </div>
                <div className="bg-[#1C2418]/85 p-6">
                    <p className="text-[11px] uppercase tracking-[0.2em] text-[#C5D48A]">Spring</p>
                    <p className="mt-4 text-sm leading-relaxed text-white/80">
                        Beds, trees, first-year watering.
                    </p>
                </div>
                <div className="bg-[#1C2418]/85 p-6">
                    <p className="text-[11px] uppercase tracking-[0.2em] text-[#C5D48A]">Stone</p>
                    <p className="mt-4 text-sm leading-relaxed text-white/80">
                        Patios and walls laid once.
                    </p>
                </div>
            </div>
        </div>
    );
}

const PREVIEWS = {
    physio: PhysioPreview,
    bakery: BakeryPreview,
    law: LawPreview,
    gym: GymPreview,
    salon: SalonPreview,
    landscape: LandscapePreview,
};

export default function DemoSitePreview({ site }) {
    const View = PREVIEWS[site.id] || PhysioPreview;
    return <View site={site} />;
}
